import { createContext, useContext } from "react";

import type { Tab } from "@design-lab/shared/types/tab";

export type ValidationState = {
  isFileSelected: boolean;
  isArtworkUploaded: boolean;
  isArtworkEnhanced: boolean;
  isQuantityValid: boolean;
  isAllQuantitiesValid: boolean;
  hasProduct: boolean;
  isAtLeastOneArtworkProcessed: boolean;
  isSomeArtworkLoading: boolean;
  isFrontArtworkUploaded: boolean;
  isBackArtworkUploaded: boolean;
  visitedTabs: Set<Tab>;
  isFrontArtworkEnhanced: boolean;
  isBackArtworkEnhanced: boolean;
  showSubTabs: boolean;
};

export const ValidationContext = createContext<ValidationState | undefined>(undefined);

export function useValidation(): ValidationState {
  const context = useContext(ValidationContext);
  if (!context) {
    throw new Error("useValidation must be used within a ValidationProvider");
  }
  return context;
}
